import React, { useState } from 'react'
import { onNumberOnlyChange } from '../EntityConfigUtils/entityConfigUtils';
import { updateBulkInterfaceDetails } from '../../../services/configurationServices';
import { SuccessToast } from '../../../CustomHooks/SuccessToast';
import { set } from 'react-hook-form';
import { ErrorToast } from '../../../CustomHooks/ErrorToast';

const InterfaceBulkEditForm = ({ setShowBulkEditModal, selectedIds, handleApplyFilters, filterValues }) => {

    const [interfacePort, setInterfacePort] = useState('');
    const [interfaceUsername, setInterfaceUsername] = useState('');
    const [interfacePassword, setInterfacePassword] = useState('');

    const [errors, setErrors] = useState({
        interfacePort: '',
        interfaceUsername: '',
        interfacePassword: '',
    });

    const clearError = (field) => {
        setErrors(prevErrors => ({
            ...prevErrors,
            [field]: ''
        }));
    };

    const bulkEditInterface = async (e) => {
        e.preventDefault();
        // let tempErrors = {
        //     interfacePort: '',
        //     interfaceUsername: '',
        //     interfacePassword: '',
        // }
        // let isValid = true;
        // if (interfacePort === '') {
        //     isValid = false;
        //     tempErrors.interfacePort = 'Interface Port is required';
        // }
        // if (interfaceUsername === "") {
        //     isValid = false;
        //     tempErrors.interfaceUsername = 'Interface Username is required';
        // }

        // if (interfacePassword === "") {
        //     isValid = false;
        //     tempErrors.interfacePassword = 'Interface Password is required';
        // }
        // if (!isValid) {
        //     setErrors(tempErrors);
        //     return;
        // }

        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const userID = user.Id || '';
            const payload = {
                "UserID": userID,
                "SiteID": filterValues.Site?.[0]?.value || null,
                "InterfaceID": selectedIds,
                // "InterfacePort": interfacePort,
                // "UserName": interfaceUsername,
                // "Password": interfacePassword,
                // "isTwoWayEnabled": true,
                // "isHooterEnabled": true,
                // "CheckInternalHooter": true,
                // "CheckExternalHooter": true
            }
            if(interfacePort){
                payload["InterfacePort"] = interfacePort
            }
            if(interfaceUsername){
                payload["UserName"] = interfaceUsername?.toString().trim()
            }
            if(interfacePassword){
                payload["Password"] = interfacePassword?.toString().trim()
            }
            const response = await updateBulkInterfaceDetails(payload)
            if (response && response.Status === 'success') {
                SuccessToast(response.Message || 'Interfaces updated successfully.')
                setShowBulkEditModal(false);
                handleApplyFilters();
            } else {
                ErrorToast(response?.Message || 'Failed to update interfaces. Please try again.')
            }
        } catch (error) {
            console.error('Error updating interfaces:', error);
            ErrorToast('An error occurred while updating interfaces. Please try again.');

        } finally {

        }
    }

    return (
        <>
            <div className='SiteFormAdditionForm border-top-0'>
                <form style={{ width: "100%" }}>
                    <div className="site-form">
                        <div className="inputMainContainer w40dot75rem">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface Port</label>
                                <input className="inputType"
                                    onKeyPress={(e) => {
                                        onNumberOnlyChange(e);
                                        clearError('interfacePort')
                                    }}
                                    value={interfacePort}
                                    onChange={(e) => setInterfacePort(e.target.value)}
                                    placeholder="Enter Interface Port*" />
                                <p className="Error_P" style={{ float: "left" }}><span> {errors?.interfacePort} </span></p>
                            </div>
                        </div>
                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface Username</label>
                                <input className="inputType"
                                    value={interfaceUsername}
                                    onChange={(e) => {
                                        setInterfaceUsername(e.target.value)
                                        clearError('interfaceUsername')
                                    }
                                    }
                                    placeholder="Enter Interface Username*"
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {errors?.interfaceUsername} </span></p>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Interface Password</label>
                                <input
                                    className="inputType"
                                    value={interfacePassword}
                                    onChange={(e) => {
                                        setInterfacePassword(e.target.value)
                                        clearError('interfacePassword')
                                    }}
                                    placeholder="Enter Interface Password*"
                                />
                                <p className="Error_P" style={{ float: "left" }}><span> {errors?.interfacePassword} </span></p>
                            </div>
                        </div>

                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Timezone</label>
                                <select
                                    className="inputType ArrowSelectClass" >
                                    <option key="0" disabled={false} value="0" id="0">Select timezone*</option>
                                    <option>UTC</option>
                                    <option>IST</option>
                                    <option>EST</option>
                                </select>
                                <p className="Error_P" style={{ float: "left" }}><span> { } </span></p>
                            </div>
                        </div> */}

                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Two Way Communication</label>
                                <div
                                    className="onlyforEnableCheckbox"
                                >
                                    <input
                                        className="checkbox_custom"
                                        type="checkbox" />
                                    <label className="mb-0" >
                                        Two Way Communication Available
                                    </label>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Enable Hooter Types</label>
                                <div className='mt-1 signTypeCheckboxLabels'>
                                    <div className="SiteTextBox SiteNameText mt-0">
                                        <div className="onlyforEnableCheckbox ml-0">
                                            <input className="checkbox_custom" type="checkbox" />
                                            <label className="mb-0">
                                                Enable Internal Hooter
                                            </label>
                                        </div>
                                    </div>
                                    <div className="SiteTextBox SiteNameText mt-0">
                                        <div className="onlyforEnableCheckbox ml-0">
                                            <input className="checkbox_custom"
                                                type="checkbox" />
                                            <label className="mb-0">
                                                Enable External Hooter
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Enable/Disable Hooter</label>
                                <div className="onlyforEnableCheckbox">
                                    <input
                                        className="checkbox_custom"
                                        type="checkbox" />
                                    <label className="mb-0">
                                        Enable Hooter
                                    </label>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </form>
            </div>
            <div style={{ textAlign: "center" }}>
                <button
                    className="DataAccessEdit mt-3"
                    onClick={bulkEditInterface}
                    style={{ width: "100px" }}>
                    <span className="ViewUpdate">Submit</span>
                </button>
                <button onClick={() => setShowBulkEditModal(false)}
                    className="DataAccessEdit mt-3"
                    style={{ width: "100px" }}>
                    <span className="ViewUpdate">Cancel</span>
                </button>
            </div>
        </>
    )
}

export default InterfaceBulkEditForm